module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "el-badge rt-badge",
    class: {
      'state-point': _vm.statePoint
    }
  }, [_vm._t("default"), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-zoom-in-center"
    }
  }, [(_vm.content !== 0 || _vm.visible) ? _c('sup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hidden && (_vm.content || _vm.content === 0 || _vm.isDot || _vm.statePoint)),
      expression: "!hidden && (content || content === 0 || isDot || statePoint)"
    }],
    ref: "sup",
    staticClass: "el-badge__content",
    class: [
      'el-badge__content--' + _vm.type,
      {
        'is-fixed': _vm.$slots.default,
        'is-dot': _vm.isDot,
        'is-stroke': _vm.isStroke
      }
    ],
    style: ({
      padding: _vm.padding,
      backgroundColor: _vm.bgColor,
      top: _vm.supTop,
      right: _vm.supRight
    }),
    domProps: {
      "textContent": _vm._s(_vm.content)
    }
  }) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-234e4a17"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/badge/rtBadge.vue
// module id = 2087
// module chunks = 137